import { getCachedSubscription } from "@/hooks/useSubscription";
import { Subscription } from "@/types/auth";

const PREVIEW_PLAN_NAME = "preview";

export const isPreviewSubscription = (
  subscription: Subscription | null | undefined,
): boolean => (subscription?.name || "").trim().toLowerCase() === PREVIEW_PLAN_NAME;

// Uso fora de componentes React (funções de serviço, hooks não-React) — a
// assinatura já está resolvida no cache global antes do app renderizar.
export const isPreviewAccount = (): boolean =>
  isPreviewSubscription(getCachedSubscription());
